import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { validateEmail } from '../../utils/abdmUtils';

const InputTextBox = ({ isRequired, label, name, onChange, inputValue }) => {
  const [value, setValue] = useState('');
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  useEffect(() => {
    if (name === 'email' && value.length > 3 && !validateEmail(value)) {
      setHasError(true);
      setErrorMessage('Please enter a valid email address');
    }
  }, [value]);

  useEffect(() => {
    if (value.length < 3) {
      setHasError(false);
      setErrorMessage('');
      return;
    }
    if (name === 'email' && validateEmail(value)) {
      setHasError(false);
      setErrorMessage('');
    }
  }, [value, errorMessage]);

  return (
    <TextField
      required={isRequired}
      variant="standard"
      margin="dense"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        disableUnderline: true,
      }}
      error={hasError}
      helperText={errorMessage}
      label={label}
      fullWidth
      id={name}
      data-testid={`test-${name}`}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

export default InputTextBox;
